import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createOperationalSite } from 'features/operationalManagement/operationalManagementSlice'
import { AppDispatch, RootState } from 'store'
import { Input } from 'components/Form/Input'
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from 'components/ModalV2/Modal'
import { Button, Flex } from 'styling/GlobalStyles'
import { Heading2, NormalText } from 'styling/TypographyV2'
import { CloseIcon } from 'assets/icons/CloseIcon'

interface CreateSiteModalProps {
  onClose: () => void
  onCreated: () => void
}

export const CreateSiteModal = ({ onClose, onCreated }: CreateSiteModalProps) => {
  const dispatch = useDispatch<AppDispatch>()
  const creatingSite = useSelector(
    (state: RootState) => state.operationalManagement.creatingSite,
  )
  const [name, setName] = useState('')
  const trimmed = name.trim()

  const handleSave = async () => {
    if (!trimmed || creatingSite) return
    const result = await dispatch(createOperationalSite({ name: trimmed }))
    if (createOperationalSite.fulfilled.match(result)) {
      onCreated()
      onClose()
    }
  }

  return (
    <Modal onClose={onClose}>
      <ModalContent maxWidth='480px'>
        <ModalHeader>
          <Flex between center>
            <Heading2>Create site</Heading2>
            <CloseIcon onClick={onClose} />
          </Flex>
        </ModalHeader>
        <ModalBody>
          <NormalText mb='1.25rem'>Create site and operational status.</NormalText>
          <Input
            label='Site name'
            placeholder='Enter here...'
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSave()
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button white onClick={onClose} disabled={creatingSite}>
            Cancel
          </Button>
          <Button orange onClick={handleSave} disabled={!trimmed || creatingSite}>
            {creatingSite ? 'Saving…' : 'Save changes'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
